import { useIntl } from "react-intl";
import {
  SEARCH_RESULT_TYPES,
  type SearchResultType
} from "../GlobalSearchWithSDO.constants";

export const useGetSearchResultsLabelByType = () => {
  const intl = useIntl();

  const workflowsLabel = intl.formatMessage({
    id: "globalSearch.identifier.workflows",
    defaultMessage: "Workflows"
  });
  const filesLabel = intl.formatMessage({
    id: "globalSearch.identifier.files",
    defaultMessage: "Files"
  });
  const dataObjectsLabel = intl.formatMessage({
    id: "globalSearch.identifier.dataRecords",
    defaultMessage: "Data Records"
  });

  const SEARCH_RESULT_TYPE_LABELS: Record<SearchResultType, string> = {
    [SEARCH_RESULT_TYPES.WORKFLOWS]: workflowsLabel,
    [SEARCH_RESULT_TYPES.FILES]: filesLabel,
    [SEARCH_RESULT_TYPES.DATA_RECORDS]: dataObjectsLabel
  };

  return {
    SEARCH_RESULT_TYPE_LABELS
  };
};
